import { EnvironmentConfig } from "@shared/src/lib/models/global";
export class JhmHttpInterceptorConfig
{
	public portalPath: string;
	public appType: string;
	public environment: EnvironmentConfig;

	public constructor (portalPath: string, appType: string, environment: EnvironmentConfig)
	{
		this.portalPath = portalPath;
		this.appType = appType;
		this.environment = environment;
	}
}
